<script setup lang="ts">
import EditGroupDrawer from '@/pages/erp/ds/auth/view/ds-group-drawer.vue'
import EditRoleDialog from '@/pages/erp/ds/auth/view/ds-role-dialog.vue'
import DsRoleMember from "@/pages/erp/ds/auth/view/ds-role-member.vue";
import type { GroupProperties } from '@/pages/erp/ds/auth/db/ds-group-types'
import Swal from 'sweetalert2'
import DsGroupMember from "@/pages/erp/ds/menu/view/ds-group-member.vue";
import ExportDialog from "@/pages/erp/du/user/view/du-management-export-dialog.vue";
definePage({
    meta: {
        action: 'manage',
        subject: 'DSGROUP',
    },
})

const compId = ref(useStorage('compNo', 'nstc').value)
const groupId = ref()
const groupDesc = ref()
const groupType = ref('R')

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
  { title: '#', key: 'id' },
  { title: '角色代碼', key: 'groupId' },
  { title: '角色說明', key: 'groupDesc' },
  // { title: '授權', key: 'auth' },
  { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: groupsData, execute: fetchGroups } = await useApi<any>(createUrl('/ds/auth/group/searchGroup', {
  query: {
    compId,
    groupId,
    groupDesc,
    groupType,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): GroupProperties[] => groupsData.value.data.groupPage.content)
const totalDatas = computed(() => groupsData.value.data.groupPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData: GroupProperties;


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (groupData: GroupProperties) => {
  voData = groupData
  console.log('editGroup: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (groupData: GroupProperties) => {
    voData = groupData
    console.log('copyGroup: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (groupData: GroupProperties) => {
  await $api('/ds/auth/group/createGroup', {
    method: 'POST',
    body: { group: groupData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchGroups()
}

const updateData = async (groupData: GroupProperties) => {
  await $api('/ds/auth/group/updateGroup', {
    method: 'PUT',
    body: { group: groupData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchGroups()
}

  // 👉 Delete data
const deleteData = async (groupData: GroupProperties) => {
  const { compId,groupId } = groupData
    $swal({
    title: `確定要刪除 ${groupData.groupId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/auth/group/deleteGroup`, {
        method: 'DELETE',
        query: {
          compId,groupId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchGroups()
      })
    }
  });

}

const clickRow = (event: any, select: { item: GroupProperties; }) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

const isEditRoleMemberVisible = ref(false)
const editGroupId = ref()

const editRoleMember = (groupId: string) => {
  console.log('editRoleMember: ', groupId)
  editGroupId.value = toCode(groupId)
  isEditRoleMemberVisible.value = true
}

const isExportDialogVisible = ref(false)

const exportBtn =  () => {
  isExportDialogVisible.value=true
  // exportUsers()
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>
    <VCardText>
      <VRow>
        <VCol
          cols="12"
          sm="4"
        >
          <AppTextField
            v-model="groupId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入角色"
          />
        </VCol>
        <VCol
          cols="12"
          sm="4"
        >
          <AppTextField
            v-model="groupDesc"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入角色說明"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />
    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
<!--        <VBtn-->
<!--          class="ml-4"-->
<!--          color="primary"-->
<!--          variant="tonal"-->
<!--          prepend-icon="tabler-download"-->
<!--          @click="exportBtn"-->
<!--        >-->
<!--          匯出-->
<!--        </VBtn>-->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增角色
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.id="{ item, index }">
        <div class="text-body-1 text-high-emphasis">
          {{ index + 1 }}
        </div>
      </template>

      <template #item.groupId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.groupId }}
          </div>
      </template>

      <template #item.groupDesc="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.groupDesc }}
          </div>
      </template>

      <template #item.groupMember="{ item }">
        <IconBtn @click.stop="editRoleMember(item.groupId)">
          <VIcon icon="tabler-user-plus" />
          <v-tooltip
            activator="parent"
            location="bottom"
          >成員管理</v-tooltip>
        </IconBtn>
      </template>
<!--      <template #item.auth="{ item }">-->
<!--        <IconBtn :to="{ name: 'erp-ds-auth-view-role-id', params: { roleId: item.groupId } }">-->
<!--          <VIcon icon="tabler-lock-plus" />-->
<!--          <v-tooltip-->
<!--            activator="parent"-->
<!--            location="bottom"-->
<!--          >授權</v-tooltip>-->
<!--        </IconBtn>-->
<!--      </template>-->
      <!-- Actions -->
      <template #item.actions="{ item }">
        <VBtn
          variant="outlined"
          density="compact"
          :to="{ name: 'erp-ds-auth-view-role-id', params: { roleId: item.groupId } }"
          style="margin-right: 10px;"
        >
          編輯
        </VBtn>
        <VBtn
          v-if="item.groupId != 'Administrator'"
          variant="outlined"
          density="compact"
          @click.stop="deleteData(item)"
        >
          刪除
        </VBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditRoleDialog
          v-if="isEditDataDrawerVisible"
          v-model:isDialogVisible="isEditDataDrawerVisible"
          :group-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />
  <DsRoleMember
    v-if="isEditRoleMemberVisible"
    v-model:isDialogVisible="isEditRoleMemberVisible"
    :group-id="editGroupId"
  />
  <ExportDialog
    v-model:isDialogVisible="isExportDialogVisible"
    export-api="/ds/auth/group/exportRole"
  />

</template>
